import React from 'react'

function FeaturesBordered({ content }) {
  return (
    <section id={'featuresBordered'} className="FeaturesBordered">
      <h2 className="FeaturesBordered-header">{content.h}</h2>
      <div className="FeaturesBordered-items">
        {content.main.map((item, _idx) => (
          <FeaturesBorderedItem
            key={`FeaturesBorderedItem-${_idx}`}
            content={item}
          />
        ))}
      </div>
    </section>
  )
}

function FeaturesBorderedItem({ content }) {
  return (
    <div
      className={'FeaturesBordered-item'}
      style={{ borderColor: content.color }}
    >
      <h3>{content.h}</h3>
      <p>{content.p}</p>
      <a
        target={'_blank'}
        href={content.cta.href}
        style={{ backgroundColor: content.color }}
      >
        {content.cta.text}
      </a>
    </div>
  )
}

export default FeaturesBordered



// WEBPACK FOOTER //
// ./src/Views/Home/FeaturesBordered.js